"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configure = void 0;
const lodash_1 = require("lodash");
const config = {
    inputs: {
        showErrors: 'onBlur'
    },
    validators: {
        email: { message: 'This email does not have a valid format' },
        length: { message: 'Must have exactly :length characters' },
        maxLength: { message: 'Must have at most :length characters' },
        minLength: { message: 'Must have at least :length characters' },
        required: { message: 'This field is mandatory' }
    }
};
function configure(options) {
    (0, lodash_1.merge)(config, options);
}
exports.configure = configure;
exports.default = config;
